import React, {
    FormEvent,
    ReactElement, useRef, useState,
} from "react";
import { Form } from "react-bootstrap";
import { SearchUsersDocument, useCreateUserMutation, User } from "../../../__generated__/api";
import Confirm from "../../confirm/Confirm";

export interface DisplayUserProps {
    id?: string;
    onSave: (id: Partial<User>) => void;
    onHide?: () => void;
    className?: string;
}
export default function DisplayUser({
    id, onSave, onHide, className,
}: DisplayUserProps): ReactElement {
    const [createUser] = useCreateUserMutation();

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");

    const emailRef = useRef<HTMLInputElement>(null);

    const onSubmit = (event?: FormEvent) => {
        event?.preventDefault();
        event?.stopPropagation();
        (async () => {
            const user = {
                firstName,
                lastName,
                email,
            };
            try {
                const saved = await createUser({
                    refetchQueries: [
                        { query: SearchUsersDocument },
                    ],
                    variables: {
                        user,
                    },
                });
                if (saved.errors) {
                    if (emailRef.current) {
                        emailRef.current.setCustomValidity("Email is invalid or already taken.");
                        emailRef.current.reportValidity();
                    }
                    return;
                }

                onSave({
                    ...user,
                    id: saved.data?.saveUser?.id as string,
                });
            } catch (err) {
                if (emailRef.current) {
                    emailRef.current.setCustomValidity("Email is invalid or already taken.");
                    emailRef.current.reportValidity();
                }
            }
        })();
        return false;
    };

    return (
        <Confirm
            shouldShow
            confirmText="Create"
            onHide={() => onHide?.()}
            onConfirm={onSubmit}
        >
            <form className="flex-grow-1" onSubmit={onSubmit}>

                <div className={className}>
                    <h5 className="mb-3 text-light">
                        {!id ? "Create" : "Edit user"}
                    </h5>
                    <Form.Group className="mb-3">
                        <Form.Label className="fw-bolder">First Name</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Alex"
                            required
                            onChange={evt => setFirstName(evt.target.value)}
                            value={firstName as string}
                        />
                        <Form.Text>
                            The first name of the user
                        </Form.Text>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label className="fw-bolder">Last Name</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Doe"
                            required
                            onChange={evt => setLastName(evt.target.value)}
                            value={lastName as string}
                        />
                        <Form.Text>
                            The last name of the user
                        </Form.Text>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label className="fw-bolder">Email Address</Form.Label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="adoe@example.com"
                            required
                            onChange={evt => {
                                setEmail(evt.target.value);
                                emailRef.current?.setCustomValidity("");
                            }}
                            value={email as string}
                            ref={emailRef}
                        />

                        <Form.Text>
                            The email address of the new user.
                        </Form.Text>
                    </Form.Group>

                </div>

            </form>
        </Confirm>
    );
}
DisplayUser.defaultProps = {
    id: undefined,
    onHide: undefined,
    className: undefined,
};
